import * as R from 'ramda';

import { ComplianceTypes } from '@/constants';
import { Chapter, ChapterUrl, ComplianceType } from '@/types';
import { camelCaseKeys } from '@/utils';

import { swapCDNHost } from '../store.utils';

export const transformChapter = (chapter: unknown): Chapter =>
  R.pipe(camelCaseKeys, c => ({
    chapterId: c.firestoreChapterId,
    firestoreChapterId: c.firestoreChapterId,
    episodeId: c.episodeId,
    episodeRevisionId: c.episodeRevisionId,
    postgrestChapterId: c.chapterId,
    name: c.name,
    description: c.description,
    formattedDescription: c.formattedDescription,
    duration: c.duration,
    type: c.type,
    resources: c.resources,
    chapterPosition: c.chapterPosition,
    isTrailer: c.isTrailer,
    isVerifiable: c.isVerifiable,
    isEthics: c.isEthics,
    isArchived: c.isArchived,
    quizIds: c.quizIds,
    compliance: c.region === 'usa' ? ComplianceTypes.CPE : ComplianceTypes.CPD,
  }))(chapter);

export const transformChapterUrl = (
  chapterUrl: any,
  compliance: ComplianceType,
): ChapterUrl =>
  R.pipe(camelCaseKeys, c => ({
    chapterId: c.contentId,
    episodeId: c.episodeId,
    url: swapCDNHost(
      compliance === ComplianceTypes.CPE
        ? (c.nasbaFile.url ?? c.file.url)
        : c.file.url,
    ),
  }))(chapterUrl);
